module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external "ng2-alfresco-core"
// module id = 1
// module chunks = 0